import fetch from 'isomorphic-fetch';
import { track } from '@gumtree/shared/src/actions';
import { trackGA4Event } from '@gumtree/shared/src/util/ga4-shared';

export default async function sendSellerReport(
    e: Event,
    reportNumber: string,
    reportText: string,
    postingId: number,
    csrfToken: string,
    selectedReason?: {
        id: string;
        label: string;
        name: string;
        value: string;
    }
) {
    e.preventDefault();

    const formData = new FormData();
    formData.append('reason_id', reportNumber);
    formData.append('other_text', reportText);
    formData.append('posting_id', String(postingId));

    track('ReportAdAttempt');

    const response = await fetch('/report/', {
        method: 'POST',
        headers: {
            accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            X_CSRF_TOKEN: csrfToken,
        },
        body: formData,
    });
    const status = await response.status;

    if (status < 400) {
        trackGA4Event({
            event: 'report_a_listing',
            formName: 'report a listing',
            formStep: 'report submitted',
            formValidation: 'success',
            formError: undefined,
            reportType: selectedReason ? [selectedReason.label] : [],
        });
    } else {
        trackGA4Event({
            event: 'report_a_listing',
            formName: 'report a listing',
            formStep: 'report submitted',
            formValidation: 'failure',
            formError: undefined,
            reportType: selectedReason ? [selectedReason.label] : [],
        });
    }
    status < 400 ? track('ReportAdSuccess') : track('ReportAdFail');
    const json = await response.json();
    return json;
}
